<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Assurance Multirisque Immeuble - PNO - PNE - Assurance des Murs</h2>
    <p>
      Un propriétaire unique d'immeuble ou un copropriétaire d'immeuble ou un propriétaire d'un local professionnel (petit commerce, restaurant, etc.), 
      autrement dit celui qui est le propriétaire des murs occupe les lieux, il est assuré par son contrat multirisque habitation pour les particuliers ou 
      le contrat multirisque professionnels pour les biens et/ou les parties communes de son bien : nous parlons d'une assurance multirisque immeuble -PNO - PNE.
    </p>
    <p>
      Quand le propriétaire des murs occupe les lieux, alors il est assuré par son contrat 
      <a href="#">Assurance Multirisque Professionnelle</a>.
    </p>
    <p>
      Si le propriétaire des murs n'occupe pas les lieux, il doit quand même assurer les murs en souscrivant une assurance Multirisque Immeuble 
      dit MRI ou une assurance Propriétaire Non Occupant dit PNE.
    </p>
    <p>
      Le locataire quant à lui assure de son côté le contenu du lieu. Cette assurance est obligatoire pour le propriétaire. En effet, les murs peuvent 
      être responsables de dommages envers un tiers (un bout de balcon qui tombe sur un passant en bas de bien immobilier). Par ailleurs, le propriétaire 
      de ces murs à tout intérêt de sauvegarder son patrimoine en cas d'effondrement, d'incendie, de destruction, incendie destructrice, vents violents, 
      vandalisme par un tiers, etc. l'assureur lui dédommagera intégralement.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2 class="section-title-purple">Pour qui ?</h2>
    <p>
      Le propriétaire qui peut être Syndic de copropriétés, Association Libre Syndicale, Syndic bénévole, Propriétaire non occupant, 
      Propriétaire occupant partiel, Société Civile Immobilière (SCI), etc. D'ailleurs le propriétaire peut demander à son locataire 
      d'assurer les murs pour son compte.
    </p>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">Type de risque client ?</h2>
    <p>
      En tant que courtier en assurance nous sommes en mesure de vous assurer quel que soit votre situation :
    </p>
    <ul class="simple-list">
      <li>Immobilier avec une fréquence SINISTRE,</li>
      <li>Immobilier AVEC sinistres majeurs,</li>
      <li>Immobilier RÉSILIES pour non paiement de prime,</li>
      <li>Immobilier à USAGE D'HABITATION ou de BUREAUX (immeubles avec présence de commerces représentant moins de 25% de la superficie totale du risque),</li>
      <li>Immobilier de GRANDE HAUTEUR,</li>
      <li>GRANDS ENSEMBLES immobiliers.</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2 class="section-title-purple">Les points clés du produit :</h2>
    <h3>A) UN PRODUIT COMPLET</h3>
    <p>Permettant de garantir très largement les biens et les responsabilités.</p>
    <p>Quelques exemples :</p>
    <ul class="simple-list">
      <li>Garantie DDE étendue aux canalisations extérieures à l'immeuble,</li>
      <li>Vandalisme, tags, graffitis,</li>
      <li>Dommages occasionnés aux installations électriques, machines, ascenseurs...,</li>
      <li>Frais de relogement,</li>
      <li>Garantie RC syndic bénévole,</li>
      <li>Garantie RC du Conseil Syndical étendue à chacun de ses membres,</li>
      <li>Valeur à neuf à 33 %.</li>
    </ul>

    <h3>B) RENONCIATION À RECOURS</h3>
    <p>Envers le syndic, l'administrateur et l'ensemble des copropriétaires et propriétaires.</p>

    <h3>C) FRANCHISE SUR MESURE</h3>
    <p>Franchise au choix et adaptée à vos besoins.</p>

    <h3>D) GRANDE CAPACITÉ DE SOUSCRIPTION</h3>
    <p>Limitation contractuelle d'indemnité (LCI) sur-mesure.</p>

    <h3>E) TARIFICATION AVANTAGEUSE</h3>
    <ul class="simple-list">
      <li>Tarification modulable en toute autonomie,</li>
      <li>Tarif attractif pour les immeubles neufs venant d'être livrés (sans sinistre).</li>
    </ul>
  </div>

  <div class="content-section">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : 
      <strong>GENERALI, SPVIE AXA, PROGEAS, APRIL, ENTORIA, AXELLIANCE, HELVETIA</strong>.
    </p>
  </div>
</app-page-layout>
